import { Component, Input, OnInit } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { Select } from '@ngxs/store';
import { isNil } from 'lodash';
import { VehicleTireCondition, VehicleConditionDisclosuresComponent } from 'remarketing-ui-components-lib';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SaComponent } from 'smartauction-frontend-micro-library';
import { DetailsQueries } from 'src/sell/lib/details/queries/details.queries';
import { ConditionAndDisclosuresQuery } from 'src/vehicles/models/queries/condition-and-disclosures.query';
import { VehiclesService } from 'src/vehicles/services/vehicle-detail/vehicles.service';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-auto-vision-condition-disclosures',
    templateUrl: './auto-vision-condition-disclosures.component.html',
    styleUrls: ['./auto-vision-condition-disclosures.component.scss'],
    imports: [VehicleConditionDisclosuresComponent, AsyncPipe]
})
export class AutoVisionConditionDisclosuresComponent extends SaComponent implements OnInit {
  @Input() showHeading = true;
  @Select(DetailsQueries.conditionsAndDisclosures) state$: Observable<ConditionAndDisclosuresQuery>;

  autoVisionConditionDisclousuresTranslations = {
    vehicleConditiontransData: '',
    conditionIndicatorTranslations: '',
    conditionAndDisclosures: ''
  };

  formatItems = {};

  constructor(private readonly translocoService: TranslocoService, private readonly vehicleService: VehiclesService) {
    super();
  }

  ngOnInit(): void {
    this.getTranslations();
  }

  translateTireCondition(tireCondition: VehicleTireCondition) {
    if (isNil(tireCondition.disclaimer)) {
      return tireCondition;
    }
    const translatedCondition = Object.assign({}, tireCondition);
    translatedCondition.disclaimer = this.translocoService.translate(tireCondition.disclaimer);
    return translatedCondition;
  }

  translateLegalStatements(legalStatements: string[]) {
    const translatedStatements: string[] = [];
    legalStatements.forEach(statement => {
      translatedStatements.push(this.translocoService.translate(statement));
    });
    return translatedStatements;
  }

  getTranslations(): void {
    const keyParams = {
      'UIComponents': {},
      'sellModule.details.conditionDisclosures': {}
    };
    this.translocoService
      .selectTranslateObject(keyParams)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(translate => {
        this.autoVisionConditionDisclousuresTranslations.vehicleConditiontransData = translate[0].vehicleCondition;
        this.autoVisionConditionDisclousuresTranslations.conditionIndicatorTranslations = translate[0].conditionIndicatorTranslations;
        this.autoVisionConditionDisclousuresTranslations.conditionAndDisclosures = translate[1].conditionAndDisclosures;

        //resetting the formatted items on language toggle
        this.formatItems = this.vehicleService.formatInventoryItems(this.state$);
      });
  }
}
